import React from "react";
import {connect} from "react-redux";
import {SignoutCallbackComponent} from "redux-oidc";
import UserManager from "../services/UserManager";
import {RouteComponentProps} from "react-router";
import {AppState} from "../store/reducers";
import {ErrorType, setError} from "../store/actions/ErrorActions";
import {push} from "connected-react-router";
import {SplashScreen} from "../scenes/Splash/SplashScreen";


const mapStateToProps = (state: AppState) => ({
    
});

const mapDispatchToProps = {
    setError,
    push
};


type ComponentProps = {
}

type Props = RouteComponentProps<{ id: string; schema: any }> &
    ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & ComponentProps;


class SignOutCallbackPage extends React.Component<Props> {
  render() {
    return (
      <SignoutCallbackComponent
        userManager={UserManager}
        successCallback={signoutResponse => this.props.push("/")}
        errorCallback={error => {
            this.props.setError("Authentication error.", ErrorType.FATAL_ERROR, error.name +'> '+error.message)
            this.props.push("/");
            // TODO: test error handling
            console.error(error);
        }}
        >
          <SplashScreen />
      </SignoutCallbackComponent>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignOutCallbackPage as unknown as React.ComponentClass<ComponentProps>);
